module.exports = "/images/Opencart.png?f252b872a18efcef74285b89e49697f3";